// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Y8XeS","label":"Section_label__3PRLU","contentWrap":"Section_contentWrap__-Is68","footer":"Section_footer__3eOUI","footerInner":"Section_footerInner__H-Hh0"};